import styled from "styled-components"

export const Container = styled.div`
  width: 100%;

  .containerTop {
    background: var(--illiniDarkBlue);
    border: 2px solid var(--illiniDarkBlue);
    border-radius: 8px 8px 0px 0px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    color: var(--white);
  }

  .containerBottom {
    background: var(--white);
    border-radius: 0px 0px 8px 8px;
    padding: 1.5rem;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  }

  ul {
    list-style: none;
    margin-left: 0;
    margin-bottom: 1rem;
  }

  h3 {
    width: 100%;
    padding-bottom: 0;
    margin-bottom: 0.5rem;
  }

  .containerBottom > ul > li::before {
    content: none;
    color: none;
  }

  li {
    margin-bottom: 1rem;
  }

  a {
    text-decoration: none;
    font-family: "Source Sans Pro";
    font-weight: 700;
    font-size: 1.2rem;
    color: var(--illiniDarkBlue);
    font-style: normal;
    margin-bottom: 0.5rem;
  }

  a:hover {
    color: var(--illiniOrange);
  }
`

export const Log = styled.div`
  width: 90%;
`
